export const normalizeMojibakeFilename = (name: string): string => {
  if (typeof name !== 'string' || !name) return '';
  const suspiciousMarkers = ['Ã', 'Å', 'Ä', 'Ð', 'Þ', 'Â', 'â'];
  const looksSuspicious = suspiciousMarkers.some((marker) => name.includes(marker));
  if (!looksSuspicious) return name;
  try {
    const bytes = new Uint8Array(name.length);
    for (let i = 0; i < name.length; i++) {
      bytes[i] = name.charCodeAt(i) & 0xff;
    }
    const repaired = new TextDecoder('utf-8').decode(bytes);
    if (!repaired || repaired.includes('\uFFFD') || repaired === name) {
      return name;
    }
    return repaired;
  } catch {
    return name;
  }
};

export const stripOriginFromUrl = (url: string, apiBaseUrl: string): string => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) {
    if (url.startsWith(apiBaseUrl)) {
      return url.slice(apiBaseUrl.length) || '/';
    }
    try {
      const parsed = new URL(url);
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return url;
    }
  }
  return url;
};

export const parseSchemaStoredName = (url: string, apiBaseUrl: string): string | null => {
  const pathOnly = stripOriginFromUrl(url, apiBaseUrl);
  const uploadsMatch = pathOnly.match(/^\/uploads\/schemas\/([^/?#]+)/i);
  if (uploadsMatch) return uploadsMatch[1];
  const apiMatch = pathOnly.match(/^\/api\/schemas\/files\/([^/?#]+)/i);
  if (apiMatch) return apiMatch[1];
  return null;
};

export const buildSchemaStaticUrl = (storedName: string): string =>
  `/uploads/schemas/${storedName}`;

export const buildSchemaDownloadUrl = (
  storedUrl: string,
  preferredName: string | undefined,
  apiBaseUrl: string
): string => {
  if (!storedUrl) return storedUrl;
  const pathOnly = stripOriginFromUrl(storedUrl, apiBaseUrl);
  const storedName = parseSchemaStoredName(pathOnly, apiBaseUrl);
  if (!storedName) return storedUrl;
  const displayName = normalizeMojibakeFilename(preferredName || storedName);
  const encodedName = encodeURIComponent(displayName);
  return `/api/schemas/files/${storedName}?name=${encodedName}`;
};

export const toSchemaDownloadApiPath = (downloadUrl: string, apiBaseUrl: string): string => {
  const pathOnly = stripOriginFromUrl(downloadUrl, apiBaseUrl);
  return pathOnly.replace(/^\/api/, '') || pathOnly;
};
